import styled from 'styled-components';
import {Dropdown} from 'antd';
import {editButtonStyles} from '../../../../../EditButton/StyledEditButton';
import Card from '../../../../../Card';

const StyledPaymentDetails = styled.div`
  .ant-alert {
    align-items: baseline;
  }
  
  .wire-payment-details {
    margin-bottom: 16px;
  }
`;


const StyledPaymentDetailsCard = styled(Card)`
  
  .ant-card-body {
    & > .ant-spin-nested-loading {
      & > .ant-spin-blur {
        &::after {
          width: calc(100% + 32px);
          left: -16px;
          top: -16px;
        }
      }
    }
  }
  
  .card-details {
    margin-bottom: 24px;
  }
  
  .ant-alert + .card-details {
    margin-top: 16px;
  }

  .ant-card-actions {
    justify-content: end;
    padding: 16px 24px;

    li {
      margin: 0;
      width: unset !important;
      &:not(:last-child) {
        border-inline-end: none;
        margin-right: 16px;
      }
    }
  }
`;


const StyledPaymentDetailsDropdownButton = styled(Dropdown.Button)`
  ${editButtonStyles};
`;

export {
  StyledPaymentDetails,
  StyledPaymentDetailsCard,
  StyledPaymentDetailsDropdownButton,
}
